import React, { useState } from 'react'
import { Header } from '../components/resuable/SapSolution';
import headerImage from '../assets/SAP/Implementation_services_cover.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cover2 from '../assets/SAP/sap-imp-cover2.png';
import { IoCloudOutline, IoAppsOutline, IoBusinessOutline, IoShieldCheckmarkOutline, IoServerOutline, IoLayersOutline, IoConstructOutline, IoPeopleOutline } from 'react-icons/io5';
import { FAQItem } from '../components/resuable/SapComponents';
import { FaMinus, FaPlus } from 'react-icons/fa';
import { IoDocumentTextOutline, IoPersonOutline, IoResizeOutline, IoSpeedometerOutline } from 'react-icons/io5';
import { motion, AnimatePresence } from 'framer-motion';
import Footer from '../components/Footer';
import { useDocumentTitle } from '../utils/useDocumentTitle';




function SAPImplementationServices() {

    useDocumentTitle('SAP Implementation services');


    const InformationSystemOverview = () => {
        return (
            <div className={`relative z-10 mobile:mt-10 -mt-20 sm:-mt-24 lg:-mt-32 xl:-mt-24 container mx-auto px-4 bg-[#49537780] rounded-lg mb-12 md:w-11/12 xl:w-10/12`}>
                <div className="lg:px-12 py-12 text-center ">
                    <p className="text-sm sm:text-base md:text-lg">"Digital transformation requires a strategic overhaul – DIAA CORP is a trusted partner for driving change. Count on us to streamline your operations and deliver cutting-edge solutions!"</p>
                </div>
            </div>
        );
    }

    const CompleteSuiteServices = () => {
        return (
            <div className="relative bg-cover bg-center flex items-center justify-center py-16">
                <div className="absolute top-0 left-0 w-full h-full"
                    style={{
                        background: `url(${cover2})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        filter: 'blur(2px)',
                    }}></div>
                <div className="absolute inset-0 bg-black opacity-50"></div>
                <div className="relative z-10 text-white text-center w-11/12 mx-auto px-4 md:w-4/5">
                    <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-12 lg:w-2/3 mx-auto">Holistic Service Portfolio:</h1>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 my-8">
                        {[
                            { title: 'Strategic Consulting and Planning' },
                            { title: 'Enterprise Architecture Design' },
                            { title: 'Full Lifecycle Solution Implementation' },
                            { title: 'Application Maintenance and Optimization' },
                            { title: 'Seamless Integration with Emerging Technologies' },
                            { title: 'Data Migration and Platform Modernization' },
                            { title: 'Customized Technical Support' },
                        ].map((item, index) => (
                            <div key={index} className="bg-[#52527E] bg-opacity-40 backdrop-blur-md p-4 rounded-2xl flex flex-col items-center justify-center h-32 w-full">
                                <h3 className="font-semibold text-sm sm:text-base md:text-lg text-center mx-auto">{item.title}</h3>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    };

    const GradientBoxes = () => {
        const boxes = [
            '50% faster implementations, 100% SAP Activate compliant',
            'Change & release automation',
            'Agile, DevOps and Continuous delivery',
            'Robotic test automation',
            'Shared services delivery mode'
        ];

        return (
            <div className="flex flex-col items-center justify-center p-4">
                <div className="flex flex-wrap justify-center gap-4 max-w-7xl">
                    {boxes.map((text, index) => (
                        <div
                            key={index}
                            className="relative bg-[#1D1F3F] text-white p-4 rounded-2xl overflow-hidden w-64 h-24 flex items-center justify-center"
                        >
                            <div className="absolute inset-0">
                                <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#4F75FF] to-[#A100FF]" />
                                <div className="absolute right-0 top-0 bottom-0 w-1 bg-gradient-to-b from-[#A100FF] to-[#4F75FF]" />
                            </div>
                            <p className="relative z-10 text-sm sm:text-base font-medium text-center px-2">{text}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const ProjectMethodology = () => {
        const stages = ['Initiate', 'Plan', 'Design', 'Build', 'Test', 'Launch'];

        const Arrow = () => (
            <svg className="w-6 h-6 text-gray-400 lg:w-8 lg:h-8 transform rotate-90 xl:rotate-0" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
        );

        return (
            <div className="bg-[#14192EB2] flex flex-col items-center justify-center p-6 py-16 xl:py-32">
                <h2 className="text-white text-3xl md:text-4xl font-bold mb-12">Project Lifecycle Approach:</h2>
                <div className="flex flex-col xl:flex-row justify-center items-center gap-6 max-w-7xl">
                    {stages.map((stage, index) => (
                        <React.Fragment key={stage}>
                            <div className="relative">
                                <div className="relative bg-[#13131C] text-white px-6 py-3 rounded-full border border-theme shadow-[0_0_30px_#a100ff] z-10">
                                    <p className="text-base md:text-lg font-medium">{stage}</p>
                                </div>
                            </div>
                            {index < stages.length - 1 && (
                                <div className="my-4 lg:my-0 lg:mx-4">
                                    <Arrow />
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        );
    };


    const certifications = [
        { icon: <IoBusinessOutline />, title: '500+ ERP Platforms', subtitle: 'Delivered' },
        { icon: <IoServerOutline />, title: '650+ Advanced Cloud Workloads', subtitle: 'Optimized' },
        { icon: <IoCloudOutline />, title: '1,100+ Modernized Data', subtitle: 'Platforms' },
        { icon: <IoAppsOutline />, title: '900+ User-Centric Application', subtitle: 'Interfaces' },
        { icon: <IoShieldCheckmarkOutline />, title: '400+ Disaster Recovery', subtitle: 'Scenarios Implemented' },
        { icon: <IoLayersOutline />, title: '300+ Industry-Specific', subtitle: 'Solutions Customized' },
        { icon: <IoConstructOutline />, title: '75+ Cross-Platform', subtitle: 'Integrations Deployed' },
        { icon: <IoPeopleOutline />, title: '150+ Third-Party Applications', subtitle: 'Seamlessly Linked' },
    ];

    const CertificationCard = ({ icon, title, subtitle }) => (
        <div className="bg-[#14192EB2] p-4 rounded-2xl shadow-md flex items-center space-x-4">
            <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#4F75FF] to-[#A100FF] flex items-center justify-center">
                <span className="text-white text-xl">{icon}</span>
            </div>
            <div className="flex-grow">
                <h3 className="text-sm md:text-base font-bold text-white">{title}</h3>
                <p className="text-xs md:text-sm text-gray-300">{subtitle}</p>
            </div>
        </div>
    );

    const Certifications = () => (
        <div className="py-12 md:py-24 flex flex-col items-center justify-center">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-white mb-8 md:mb-12 text-center">Certified Enterprise Solution Provider:</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 px-4 w-11/12 mx-auto">
                {certifications.map((cert, index) => (
                    <CertificationCard key={index} icon={cert.icon} title={cert.title} subtitle={cert.subtitle} />
                ))}
            </div>
        </div>
    );


    const FAQSection = () => {
        const [openIndex, setOpenIndex] = useState(null);

        const faqs = [
            {
                icon: <IoDocumentTextOutline />,
                title: "Strategic Planning",
                answer: `Develop actionable project timelines, identify risks, and establish contingency measures to secure implementation success.`
            },
            {
                icon: <IoPersonOutline />,
                title: "Expert Leadership",
                answer: "A seasoned implementation manager leads the team, ensuring alignment with industry best practices and organizational goals."
            },
            {
                icon: <IoResizeOutline />,
                title: "Comprehensive Assessment",
                answer: "Conduct a total cost analysis (TCA) encompassing downtime, system requirements, and operational expenditures."
            },
            {
                icon: <IoServerOutline />,
                title: "Streamlined Installation",
                answer: "Follow structured guidelines and proven methodologies to ensure efficient, problem-free deployment of enterprise systems."
            },
            {
                icon: <IoSpeedometerOutline />,
                title: "Robust Validation & Enablement",
                answer: "Perform exhaustive testing scenarios, including stress and load testing, and conduct hands-on training for all key stakeholders."
            },
        ];

        const toggleFAQ = (index) => {
            setOpenIndex(openIndex === index ? null : index);
        };

        return (
            <div className="flex flex-col items-start justify-center p-4 space-y-2 2xl:max-w-7xl mx-auto">
                {faqs.map((faq, index) => (
                    <div key={index} className="w-full">
                        <div
                            className="flex items-center justify-between w-full bg-[#1E2235] rounded-lg p-4 cursor-pointer"
                            onClick={() => toggleFAQ(index)}
                        >
                            <div className="flex items-center space-x-4">
                                <div className="text-[#A100FF]">{faq.icon}</div>
                                <span className="text-white">{faq.title}</span>
                            </div>
                            <motion.div
                                className="text-[#A100FF]"
                                animate={{ rotate: openIndex === index ? 180 : 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                {openIndex === index ? <FaMinus /> : <FaPlus />}
                            </motion.div>
                        </div>
                        <AnimatePresence>
                            {openIndex === index && (
                                <motion.div
                                    initial={{ opacity: 0, height: 0 }}
                                    animate={{ opacity: 1, height: 'auto' }}
                                    exit={{ opacity: 0, height: 0 }}
                                    transition={{ duration: 0.3 }}
                                    className="bg-[#14192E] overflow-hidden"
                                >
                                    <div className="p-4 mt-2 rounded-lg">
                                        <p className="text-white">{faq.answer}</p>
                                    </div>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="bg-bg text-white">
            <Header
                title="DIAA CORP Digital Transformation Services"
                description="Transform your business processes with our tailored solutions that ensure seamless integration, rapid deployment, and robust performance."
                backgroundImage={headerImage}
                isExploreBtn={true}
            />
            <InformationSystemOverview />
            <div>
                <div className="w-11/12 text-white md:p-8 rounded-lg mx-auto">
                    <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-center mb-4">
                        Why Choose DIAA CORP for Digital Transformation?
                    </h2>
                    <h3 className="text-base sm:text-lg md:text-xl font-medium text-center mb-6 text-[#F1F1F1F1]">
                        Comprehensive Solutions for Future-Ready Operations
                    </h3>
                    <p className="text-sm sm:text-base md:text-lg leading-7 text-[#F1F1F1F1]">
                        DIAA CORP understands that modernizing your core processes is key to achieving long-term success. Our expertise lies in creating agile systems that enhance operational efficiency, improve data visibility, and support growth. With a wealth of experience, our team provides the tools and expertise needed to overcome complex challenges and drive innovation.
                    </p>
                </div>
            </div>
            <div className="mx-auto mt-12 xl:mt-24">
                <CompleteSuiteServices />
            </div>
            <div>
                <div className="w-11/12 text-white md:p-8 rounded-lg mx-auto mt-12 xl:mt-24">
                    <h3 className="text-base sm:text-lg md:text-xl font-medium text-center mb-6 text-[#F1F1F1F1]">
                        Accelerated Digital Transformation:
                    </h3>
                    <p className="text-sm sm:text-base md:text-lg leading-7 text-center text-[#F1F1F1F1]">
                        DIAA CORP leverages proven methodologies to streamline your digital transformation journey. Our solutions are designed to minimize downtime and maximize efficiency, whether implemented on-premises, in the cloud, or through hybrid models.
                    </p>
                </div>
                <div className="mx-auto mt-12 xl:mt-24">
                    <GradientBoxes />
                </div>
                <div className="mx-auto mt-12 xl:mt-24">
                    <ProjectMethodology />
                </div>
                <div className="mx-auto mt-12 xl:mt-24">
                    <Certifications />
                </div>
                <div className="mx-auto mt-12 xl:mt-24">
                    <div className="w-11/12 text-white md:p-8 rounded-lg mx-auto">
                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-center mb-4">
                            Features of DIAA CORP Implementation Services:
                        </h2>
                        <h3 className="text-base sm:text-lg md:text-xl font-medium text-center mb-6 text-[#F1F1F1F1]">
                            Strategic Planning
                        </h3>
                    </div>
                </div>
                <div className="xl:w-1/2 mx-auto mt-12 xl:mt-24">
                    <FAQSection />
                </div>
            </div>
            <div>
                <Footer />
            </div>
        </div >
    )
}

export default SAPImplementationServices